import React from 'react'
import PrintView from '../../components/PrintView/PrintView'
import image from '../../assets/images/sunkisses-product.jpg'

const Sunkissed = () => {
  return <PrintView
  title='The perfect amount of Sunkissed'
  heading='The perfect amount of Sunkissed'
  content='A young leopard resting in Wilpattu National Park during a beautiful golden sunset. This park is famous for leopards and other animals. The golden light in the photo makes it special and artistic. It’s one of my favorite pictures from Wilpattu.'
  printImage={image}
 />
}

export default Sunkissed